import React from "react"

import SidebarFilter from "./sidebarFilter"

class CollectionSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      types: [
        {
          "name": "Beer",
          "tag": "beer"
        },
        {
          "name": "Champagne",
          "tag": "champagne"
        },
        {
          "name": "Champagne Flute",
          "tag": "champagne flute"
        },
        {
          "name": "Growler",
          "tag": "growler"
        },
        {
          "name": "Olive Oil / Vinegar",
          "tag": "Olive Oil / Vinegar"
        },
        {
          "name": "Pint Glass",
          "tag": "Pint Glass"
        },
        {
          "name": "Red Wine",
          "tag": "Red Wine"
        },
        {
          "name": "Rocks Glass",
          "tag": "rocks glass"
        },
        {
          "name": "White Wine",
          "tag": "white wine"
        },
        {
          "name": "White Wine - Blue Bottle",
          "tag": "White Wine - Blue Bottle"
        },
        {
          "name": "Wine Glass",
          "tag": "wine glass"
        }
      ],
    };
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  handleFilterChange(value,name) {
    this.props.onFilterChange(value, name);
  }

  deepFilter(arr1, arr2) {
    const filteredArray = arr2.filter(({tag}) => arr1.includes(tag))
    return filteredArray
  }

  componentDidMount() {
    this.setState({
      types: this.deepFilter(this.props.collectionTags, this.state.types),
    })
  }
  
  render() {
    return (
      <div className="column is-one-quarter">
        <SidebarFilter
          heading="Type"
          name="typeFilter"
          types={this.state.types}
          currentFilter={this.props.typeFilter}
          onFilterChange={this.handleFilterChange}
        />
      </div>
    )
  }
}

export default CollectionSidebar